var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPat8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9974 16.1146H5.9974C3.0574 16.1146 2.16406 15.2213 2.16406 12.2812V5.61458C2.16406 2.67458 3.0574 1.78125 5.9974 1.78125H9.9974C12.9374 1.78125 13.8307 2.67458 13.8307 5.61458V12.2812C13.8307 15.2213 12.9374 16.1146 9.9974 16.1146ZM5.9974 2.78125C3.61073 2.78125 3.16406 3.23458 3.16406 5.61458V12.2812C3.16406 14.6613 3.61073 15.1146 5.9974 15.1146H9.9974C12.3841 15.1146 12.8307 14.6613 12.8307 12.2812V5.61458C12.8307 3.23458 12.3841 2.78125 9.9974 2.78125H5.9974Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33073 5.11328H6.66406C6.39073 5.11328 6.16406 4.88661 6.16406 4.61328C6.16406 4.33995 6.39073 4.11328 6.66406 4.11328H9.33073C9.60406 4.11328 9.83073 4.33995 9.83073 4.61328C9.83073 4.88661 9.60406 5.11328 9.33073 5.11328Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00208 14.1878C7.15542 14.1878 6.46875 13.5011 6.46875 12.6544C6.46875 11.8078 7.15542 11.1211 8.00208 11.1211C8.84875 11.1211 9.53542 11.8078 9.53542 12.6544C9.53542 13.5011 8.84875 14.1878 8.00208 14.1878ZM8.00208 12.1144C7.70875 12.1144 7.46875 12.3544 7.46875 12.6478C7.46875 12.9411 7.70875 13.1811 8.00208 13.1811C8.29542 13.1811 8.53542 12.9411 8.53542 12.6478C8.53542 12.3544 8.29542 12.1144 8.00208 12.1144Z",
    fill: "#053CC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPat8);
export default __webpack_public_path__ + "static/media/pat8.2d17ea227d100b8e4a7f123aca383ca2.svg";
export { ForwardRef as ReactComponent };